import { Container, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ProviderCard from "../../components/cards/ProviderCard";
import BoxContainer from "../../components/container/boxContainer";
import { useSnackbar } from "../../lib/context/snackbarContext";
import { getAllWorkersBySubserviceId } from "../../services/workerFn";
import { t } from "i18next";
// import FIlters from "../carService/FIlters";

const AllCompanies = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showSnackbar } = useSnackbar();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [allWorkers, setAllWorkers] = useState([]);

  useEffect(() => {
    if (id) {
      fetchAllWorkers();
    }
  }, [id]);

  const fetchAllWorkers = async () => {
    try {
      setIsLoading(true);
      const response = await getAllWorkersBySubserviceId(id);
      if (response?.data.status === "success") {
        setAllWorkers(response.data.data);
      } else {
        showSnackbar(response.data.message, "error");
      }
    } catch (error) {
      showSnackbar(error.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickOnCard = (data) => {
    navigate(`/worker-detail/${data?._id}?service=${id}`);
  };

  return (
    <Container sx={{ maxWidth: "1100px !important", my: 6 }}>
      <Container maxWidth={"sm"} sx={{ p: 0, mb: 4 }}>
        <Typography
          variant="heading_services"
          component={"h1"}
          textAlign={"center"}
          lineHeight={"normal"}
        >
          {state?.subTitle}
        </Typography>
      </Container>
      {/* <FIlters /> */}
      <BoxContainer sx={{ mt: 3 }}>
        {allWorkers?.length === 0 ? (
          <Typography
            variant="h6"
            fontWeight={600}
            textAlign={"center"}
            textTransform={"capitalize"}
          >
            {t("workersNotFound")} !
          </Typography>
        ) : (
          <Typography
            variant="h6"
            fontWeight={600}
            textTransform={"capitalize"}
          >
            {t("allWorkers")}
          </Typography>
        )}
      </BoxContainer>

      <Stack>
        {allWorkers.map((val, index) => {
          return (
            <ProviderCard
              key={index}
              data={val}
              index={index}
              handleClickOnCard={handleClickOnCard}
            />
          );
        })}
      </Stack>
    </Container>
  );
};

export default AllCompanies;
